import moment from 'moment-timezone';

import logger from 'utils/logger.util';

/** Moment locale: weeks run Monday 00:00 – Sunday end of day (ISO-style dow/doy). */
export const SCHEDULER_WEEK_LOCALE = 'slick-scheduler-week';

let localeRegistered = false;

const L = logger('schedulerWeekBound.util');

export const ensureSchedulerWeekLocale = () => {
  if (localeRegistered) return;
  moment.locale(SCHEDULER_WEEK_LOCALE, {
    parentLocale: 'en',
    week: { dow: 1, doy: 4 },
  });
  localeRegistered = true;
};

ensureSchedulerWeekLocale();

export const getSchedulerWeekStartMonday = (m) => {
  if (!m || !moment.isMoment(m) || !m.isValid()) {
    L.warn('getSchedulerWeekStartMonday()', 'Invalid moment instance, returning silent `now` date.');
    return moment().locale(SCHEDULER_WEEK_LOCALE).startOf('week').startOf('day');
  }
  return m.clone().locale(SCHEDULER_WEEK_LOCALE).startOf('week').startOf('day');
};

export const getSchedulerWeekEndSunday = (m) => {
  if (!m || !moment.isMoment(m) || !m.isValid()) {
    return getSchedulerWeekStartMonday(moment()).clone().add(6, 'days').endOf('day');
  }
  return m.clone().locale(SCHEDULER_WEEK_LOCALE).endOf('week').endOf('day');
};

export const formatSchedulerWeekUrlSegment = (date) => {
  ensureSchedulerWeekLocale();
  const m = moment.isMoment(date) ? date.clone() : moment(date);
  if (!m.isValid()) return 'Invalid date';
  return m.locale(SCHEDULER_WEEK_LOCALE).format('W[W]YYYY');
};

/**
 * @param {string} str - e.g. 15W2024
 * @param {string | null | undefined} timeZone - salon IANA zone; when set, week bounds match that wall clock (same as calendar picks)
 * @returns {import('moment').Moment | null} start of that scheduler week (Monday 00:00 in `timeZone`, or local if omitted)
 */
export const parseSchedulerWeekUrlSegment = (str, timeZone) => {
  ensureSchedulerWeekLocale();
  const m = timeZone ? moment.tz(str, 'W[W]YYYY', true, timeZone) : moment(str, 'W[W]YYYY', true);
  if (!m.isValid()) return null;
  // W[W]YYYY parses to Monday 00:00 of that ISO week; with dow 1 locale, startOf('week') stays at Monday.
  return m.clone().locale(SCHEDULER_WEEK_LOCALE).startOf('week').startOf('day');
};
